import "es6-shim";
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import "../../styles/Popup.css";

interface IPatientEditPopupProps {
    visible: boolean,
    title: string,
    message?: string,
    largeSize?: string,
    children?: React.ReactNode,
    hidepopup(): void,
    cancel?(): void,
    save?(): void,
    onClick?(e): void
}
export const PatientEditPopup = (props: IPatientEditPopupProps) => {
    return (
        <div
            onClick={(e) => {
                e.preventDefault();
                props.onClick && props.onClick(e)
            }}
        >
            <Modal
                onHide={props.hidepopup}
                show={props.visible}
                dialogClassName="modal-90w"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-lg" className="patient-edit-popup-title">
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: "center" }}>
                    <div className="row">
                        {props.children}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/PatientEditPopup.tsx